export type PickerValue = {
  hour: string;
  minute: string;
  meridiem: string;
};

export const hourOptions = Array.from({ length: 12 }, (_, idx) =>
  (idx + 1).toString().padStart(2, "0")
);

export const minuteOptions = Array.from({ length: 60 }, (_, idx) =>
  idx.toString().padStart(2, "0")
);

export const meridiemOptions = ["AM", "PM"];

export const pickerItemHeight = 40;

export const parseTimeToPickerValue = (time: string): PickerValue => {
  if (!time) {
    return { hour: "09", minute: "00", meridiem: "AM" };
  }
  const [hours, minute] = time.split(":");
  let hourNumber = parseInt(hours ?? "0", 10);
  let meridiem = "AM";
  if (hourNumber >= 12) {
    meridiem = "PM";
  }
  if (hourNumber === 0) {
    hourNumber = 12;
  } else if (hourNumber > 12) {
    hourNumber -= 12;
  }
  return {
    hour: hourNumber.toString().padStart(2, "0"),
    minute: (minute ?? "00").padStart(2, "0"),
    meridiem,
  };
};

export const pickerValueToTime = ({ hour, minute, meridiem }: PickerValue) => {
  let hourNumber = parseInt(hour, 10);
  if (meridiem === "AM") {
    if (hourNumber === 12) {
      hourNumber = 0;
    }
  } else if (meridiem === "PM" && hourNumber < 12) {
    hourNumber += 12;
  }
  return `${hourNumber.toString().padStart(2, "0")}:${minute}`;
};

export const displayPickerValue = ({ hour, minute, meridiem }: PickerValue) =>
  `${hour}:${minute} ${meridiem}`;

export const pickerValuesEqual = (a: PickerValue, b: PickerValue) =>
  a.hour === b.hour && a.minute === b.minute && a.meridiem === b.meridiem;

export const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max);
